import ReactDOM from "react-dom";
import "./index.css";
import { App } from "./App";
import { BrowserRouter } from "react-router-dom";
import { ReportContextProvider } from "./components/HOC/ReportContext";
import { createTheme } from "react-data-table-component";

createTheme("darkCustom", {
  text: { primary: "#FFFFFF", secondary: "#A0A0A0" },
  background: { default: "#424242" },
  context: { background: "#424242", text: "#FFFFFF" },
  divider: { default: "#4F4F4F" },
  button: { default: "#A0A0A0", hover: "rgba(255,255,255,.1)", focus: "rgba(255,255,255,.15)", disabled: "rgba(255,255,255,.18)" },
  highlightOnHover: { default: "#4A4A4A", text: "#FFFFFF" },
  striped: { default: "#464646", text: "#FFFFFF" },
}, "dark");

ReactDOM.render(
  (
    <ReportContextProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ReportContextProvider>
  ),
  document.getElementById("root"),
);
